import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import useCenterFocusedField from 'hooks/useCenterFocusedField';
import Maintenance from 'modules/admin/components/Error/Maintenance';
import NoInternet from 'modules/admin/components/Error/NoInternet';
import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import {
  maintenanceModeSelector,
  offlineStatusSelector,
} from 'store/auth/selectors/systemStatusSelectors';
import { setOfflineStatus } from 'store/auth/slices/SystemStatusSlice';

import RouteWrapper from './routes/RouteWrapper';

import 'react-toastify/dist/ReactToastify.css';
export default function App() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isOffline = useSelector(offlineStatusSelector);
  const isMaintenanceMode = useSelector(maintenanceModeSelector);

  // every form in the app: on phones, centre the field the user taps
  useCenterFocusedField();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const goOffline = () => dispatch(setOfflineStatus(true));
    const goOnline = () => dispatch(setOfflineStatus(false));

    if (!navigator.onLine) {
      goOffline();
    }

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, [dispatch]);

  if (isOffline) {
    return <NoInternet />;
  }

  if (isMaintenanceMode) {
    return <Maintenance />;
  }

  return (
    <>
      <ErrorBoundary>
        <ToastContainer />
        <RouteWrapper />
      </ErrorBoundary>
    </>
  );
}
